import { matchPath } from "react-router"

/**
 * Разбор адреса по шаблону маршрута — обёртка над `matchPath` из react-router 6.
 *
 * В шестой версии у функции поменялся порядок аргументов (сначала шаблон, потом
 * адрес) и умолчание: совпадение стало полным. В пятой при передаче шаблона
 * строкой оно было неполным, поэтому здесь явно стоит `end: false` — иначе
 * страницы со вложенными адресами перестали бы находить свой идентификатор.
 *
 * Порядок аргументов оставлен как был (адрес, шаблон): так читаются все два
 * десятка мест вызова, и правка свелась к смене импорта.
 */
export function matchRoute<TParams extends object = Record<string, string | undefined>>(
    pathname: string,
    pattern: string
) {
    const match = matchPath({ path: pattern, end: false }, pathname)

    if (!match) {
        return null
    }

    return { ...match, params: match.params as unknown as TParams }
}
